import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var AppHolder = /*#__PURE__*/function () {
  function AppHolder() {
    _classCallCheck(this, AppHolder);
  }

  _createClass(AppHolder, null, [{
    key: "setInstance",
    value: function setInstance(name, app) {
      AppHolder._apps[name] = app;
    }
  }, {
    key: "getInstance",
    value: function getInstance(name) {
      var app = AppHolder._apps[name];

      if (!app) {
        throw Error("[".concat(name, "] FronteggApp not found"));
      }

      return app;
    }
  }]);

  return AppHolder;
}();
AppHolder._apps = {};